<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">{{ $t("Affiliate Program") }}</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>

    <div class="container-center lg animated fadeIn">
      <div class="text-center">
        <p>
          It's time to get free coins by invite friends
        </p>
      </div>

      <div class="panel panel-filled">
        <div class="panel-body">
          <p class="text-center">
            <qrcode
              v-if="showQR"
              v-model="link"
              :options="{ size: 150 }"
              class="img-thumbnail"
            ></qrcode>
          </p>
          <p
            class="text-accent pointer text-center"
            v-if="showQR"
            v-on:click="showQR = false"
          >
            <i class="far fa-times-circle fa-2x"></i>
          </p>
        </div>

        <div class="panel-body">
          <div class="form-group">
            <label>My Affiliate ID</label>
            <input type="text" v-model="getUser.hash" class="form-control" />
          </div>
          <div class="form-group">
            <label>Affiliate Link</label>
            <input v-model="link" class="form-control" />
            <span
              class="text-accent pointer"
              v-if="!showQR"
              v-on:click="showQR = true"
            >
              <i class="fad fa-qrcode m-r-xs"></i> Show QR code
            </span>
          </div>
        </div>

        <div class="panel-body text-center">
          <div class="col-xs-6">
            <div class="form-group">
              <label>Share</label>
              <a
                target="_blank"
                v-bind:href="
                  'https://www.facebook.com/sharer/sharer.php?u=' + link
                "
                class="m-l-sm"
              >
                <i class="fab fa-facebook fa-2x"></i>
              </a>
              <a
                target="_blank"
                v-bind:href="
                  'https://twitter.com/intent/tweet?text=Buy Bitcoin &url=' +
                    link
                "
                class="m-l-sm"
              >
                <i class="fab fa-twitter fa-2x"></i>
              </a>
            </div>
          </div>
          <div class="col-xs-6">
            <i class="fad fa-user-plus"></i> Referral Friends
            <p class="font-bold c-white">
              {{ table_rows.length }}
            </p>
          </div>
        </div>

        <div class="panel-body">
          <div class="form-group">
            <label for="filter" class="sr-only">Filter</label>
            <input
              type="text"
              class="form-control filter"
              v-model="filter"
              placeholder="Search..."
            />
          </div>
          <div v-if="table_rows.length == 0">
            <div class="container-center lg loader-example text-center">
              <i class="fad fa-search fa-4x"></i>
              <h4>You have no referral.</h4>
            </div>
          </div>
          <div v-else>
            <datatable
              :columns="history_columns"
              :data="table_rows"
              :filter-by="filter"
              class=""
            >
              <template slot-scope="{ row }">
                <tr class="pointer">
                  <td>
                    <div class="row">
                      <div class="col-xs-12">
                        {{ row.email }}
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </datatable>
            <div class="pager-footer">
              <datatable-pager
                v-model="page"
                type="abbreviated"
                :per-page="per_page"
                class="text-center"
              ></datatable-pager>
            </div>
          </div>
        </div>
      </div>
      <referral></referral>
    </div>
  </div>
</template>

<script>
import { SITE_URL } from "../../config";
import { mapGetters } from "vuex";
import user from "@/api/user";
import nativeToast from "native-toast";
import moment from "moment";

import Vue from "vue";
import VueQrcode from "@chenfengyuan/vue-qrcode";
Vue.component(VueQrcode.name, VueQrcode);

import referral from "@/components/referral";

export default {
  components: {
    referral
  },
  data() {
    return {
      showQR: false,
      link: null,
      filter: "",
      ready: false,
      table_rows: [],
      history_columns: [
        {
          label: "Email",
          field: "email",
          sortable: false
        }
      ],
      page: 1,
      per_page: 10
    };
  },
  computed: mapGetters(["getUser"]),
  methods: {
    getdata() {
      this.table_rows = [];
      user
        .refers()
        .then(res => {
          this.ready = true;
          res.data.forEach(e => {
            e.createdAt = moment(e.createdAt).format("YYYY-MM-DD, HH:mm:ss");

            this.table_rows.push(e);
          });
        })
        .catch(error => {
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 3000,
            type: "error"
          });
        });
    }
  },
  created() {
    this.getdata();
    this.link = SITE_URL + "/r/" + this.getUser.hash;
  }
};
</script>

<style scoped>
.pager-footer {
  position: static;
}
</style>
